var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},_vm._l((_vm.list),function(i){return _c('Item',_vm._b({key:i.title},'Item',i,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }